export default [
  { 
    path: '/faq', 
    name: 'FAQList', 
    component: () => import('@/views/faq/List'), 
    meta: {
      breadcrumbs: [
        { text: 'ถามตอบ', disabled: true }
      ]
    }
  },
  { 
    path: '/faq/create', 
    name: 'FAQCreate', 
    component: () => import('@/views/faq/Form'), 
    meta: {
      form_type: 'CREATE',
      form_title: 'สร้าง',
      breadcrumbs: [
        { text: 'คำถาม', to: `/faq` },
        { text: `สร้างคำถาม` },
      ]
    }, 
  },
  { 
    path: '/faq/:id/edit', 
    name: 'FAQEdit', 
    component: () => import('@/views/faq/Form'), 
    meta: {
      form_type: 'EDIT',
      form_title: 'แก้ไข',
      breadcrumbs: [
        { text: 'คำถาม', to: `/faq` },
        { text: `แก้ไขคำถาม` },
      ]
    }, 
  },
]